import React, { useEffect, useState } from "react";
import axios from 'axios'; // npm i axios
import Conexao from '../../Config/conexao';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import VariavelGlobal from '../../Config/Variavelglobal'
import { Container, ContainerForm, TextFieldStyled } from "../../../site/styles";
import styles from './StyledButton.module.css';
import { Navbar, Row, Col, Offcanvas } from 'react-bootstrap';

function  Cadastro_Sondagem(props) {

    const [sonda, setSonda] = useState('')
    const [showSidebar, setShowSidebar] = useState(false);
    const [processo, setProcesso] = useState("")
    const [cliente, setCliente] = useState("")
    const [obra, setObra] = useState("")
    const [cidade, setCidade] = useState("")
    const [sondagem, setSondagem] = useState("")
    const [inclinacao, setInclinacao] = useState("")
    const [azimute, setAzimute] = useState("")
    const [alvo, setAlvo] = useState("")
    const [habilitar, setHabilitar] = useState(false)
    const [bnthabilitar, setBnthabilitar] = useState("true")
    const [setorLogado, setSetorLogado] = useState();
    const [ncontrato, setNcontrato] = useState();
    const [status, setStatus] = useState()
    const valor1 = processo;
    const valor2 = obra;
    const [liClicked, setLiClicked] = useState(false);
    const handleShowSidebar = (index) => {
        setShowSidebar(true);
        //setBackgroundImage(images[index]);

    }
    const handleCloseSidebar = () => {
        setShowSidebar(false);
        
      }
    function carregaUser() { setSetorLogado(localStorage.usuario) };
    useEffect(() => { carregaUser() }, []);
    const handleBuscar = () => {
        // Lógica para buscar
        console.log('Buscar clicado');
    };
    async function getNivel() {
        const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
        if (res.data.success === false) {
            //  setLoading(false)
            //  falha();  
        } else {

            if (res.data.nivel === "Gerente") {

                setBnthabilitar(false)
                VariavelGlobal.ButtonEnable = false
                console.log("Nivel_Dentro  " + res.data.nivel);
                console.log("Usuario  " + setorLogado);
            } else {
                if (res.data.nivel === "Supervisor") {

                    setBnthabilitar(false)
                    VariavelGlobal.ButtonEnable = false
                } else {

                    setBnthabilitar(true)
                    VariavelGlobal.ButtonEnable = true
                }
            }

        }
    };

    function LIMPAR() {

        setSonda('')

        setCliente("")
        setObra("")
        setCidade("")
        setSondagem("")
        setInclinacao("")
        setAzimute("")
        setAlvo("")
        setNcontrato('')
    }


    const BuscarProcesso = async (e) => {
        e.preventDefault()
        console.log('buscaRDO', processo);
        const res = await axios.get(Conexao.api + 'ListaCadastroSondagem.php?processo=' + processo);
        //console.log(Conexao.api + 'ListaProjetoParaSondagem.php?processo=' + processo)
        if (res.data.success === true) {
            setCliente(res.data.result[0].cliente);
            setObra(res.data.result[0].obra);
            setCidade(res.data.result[0].cidade);
            //  setNcontrato(res.data.result[0].ncontrato);

            setHabilitar(false);
            setBnthabilitar(false);
            VariavelGlobal.ButtonEnable = false;
            getNivel();
        } else {
            VariavelGlobal.ButtonEnable = true;
            LIMPAR();
            setHabilitar(false);
            setBnthabilitar(false);

            alert('Cadastro NÃO REALIZADO');
        }
        console.log('retornobusca RDO', res.data.result);
    };

    async function BuscarCadastro(e) {
        e.preventDefault()
        const res = await axios.get(Conexao.api + 'ListaCadastroSondagem.php?processo=' + processo);


        if (res.data.success === true) {
            setCliente(res.data.result[0].cliente)
            setObra(res.data.result[0].obra)
            setCidade(res.data.result[0].cidade)
            setSondagem(res.data.result[0].sondagem)
            setInclinacao(res.data.result[0].inclinacao)
            setAzimute(res.data.result[0].azimute)
            setAlvo(res.data.result[0].alvo)
            setSonda(res.data.result[0].sonda)
            setNcontrato(res.data.result[0].ncontrato)

            setObra(res.data.result[0].obra)
            setCliente(res.data.result[0].cliente)
            setCidade(res.data.result[0].cidade)
            setStatus(res.data.result[0].status)


            setHabilitar(true)
            setBnthabilitar(false)
            VariavelGlobal.ButtonEnable = false
            //getNivel()
            // BuscarProcesso()

        } else {

            //BuscarProcesso()
            // BuscarSonda()
            setHabilitar(false)
        }
        console.log('retornobusca RDO', res.data.result)



    };



    async function BuscarSonda() {

        const res = await axios.get(Conexao.api + 'ListaSondaParaSondagem.php?sonda=' + "");

        if (res.data.success) {
            //  setSonda(res.data.result)


        } else {

            //  setSonda([])

        }

        console.log('SONDAS  ' + res.data.result)
        console.log('SONDAS2  ' + sonda)
    };



    async function SalvarCadastro() {
        const obj = {
            processo, cliente, obra, cidade, sondagem, inclinacao, azimute, alvo, sonda, ncontrato
        };

        const res = await axios.post(Conexao.api + 'SalvarCadastroSondagem.php', obj);

        console.log('SalvarLista', obj)

        if (res.data.success === true) {
            alert('Cadastro Atualizado Sucesso!')
        }


    };








    return (<div className="home">
        <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1300px', minWidth: '1600px' }} >

            <div className="sidebar-button">
                <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
                    <div className="icon-container">
                        <i className="bi bi-list icon-circle"></i>
                    </div>
                </Button>

            </div>
            <div className="language-buttons">
                <Button variant="outline" className="rounded-circle">
                    <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
                </Button>
                <Button variant="outline" className="rounded-circle">
                    <img src="../Images/BandeiraPortugal.png" alt="Português" />
                </Button>
            </div>
            <div className="sidebar-Text">
                <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginLeft: '0%', }}>Sondagem</text>
            </div>

            <Container>
                <ContainerForm>

                    <form className="container-fluid ">
                        <br />
                        <br />
                        <body >
                            <div class="container text-center">
                                <div className="d-flex justify-content-center align-items-center" >
                                    <div className="col-6">
                                        <h7>Processo:</h7>
                                        <input
                                            name='processo'
                                            id='processo'
                                            className='form-control text-center colorInput'
                                            disabled={false}
                                            value={processo}
                                            onChange={(e) => setProcesso(e.target.value)}

                                        />

                                    </div>
                                </div>
                            </div>
                        </body>
                        <br />
                        <div className="row d-flex mt-2 align-items-end justify-content-center">
                            <div className="col-4">
                                <div className="btn btn-outline-success-center">
                                    <button onClick={BuscarCadastro} className="btnlogin me-md-2">Buscar</button>
                                </div>
                            </div>
                        </div>
                        <br />

                        <body  >
                            <div class="container text-center">
                                <div class="row align-items-start">

                                    <br />
                                    {/* <div class="col-6">
                                        <h7>Processo:</h7>
                                        <input name='cliente' id='cliente' className='form-control text-center colorInput ' disabled={habilitar} value={cliente} onChange={(e) => setCliente(e.target.value)} ></input>
                                    </div> */}

                                    <br />
                                    <div class="col-6">
                                        <h7>Equipamentos:</h7>
                                        <input name='cliente' id='cliente' className='form-control text-center colorInput ' disabled={false} value={cliente} onChange={(e) => setCliente(e.target.value)} ></input>
                                    </div>


                                </div>
                            </div>
                        </body>
                        <br />

                        <body  >
                            <div class="container text-center">
                                <div class="row align-items-start">

                                    <br />


                                    <div class="col-6">
                                        <h7>Contrato:</h7>
                                        <input name='obra' id='obra' className='form-control text-center colorInput ' disabled={false} value={ncontrato} onChange={(e) => setNcontrato(e.target.value)} ></input>
                                    </div>


                                    <div class="col-6">
                                        <h7>Frente de Serviço:</h7>
                                        <input name='cidade' id='cidade' className='form-control text-center colorInput ' disabled={false} value={obra} onChange={(e) => setObra(e.target.value)} ></input>
                                    </div>

                                </div>
                            </div>
                        </body>
                        <br />
                        <body  >
                            <div class="container text-center">
                                <div class="row align-items-start">

                                    <br />


                                    <div class="col-6">
                                        <h7>Nome Fantasia:</h7>

                                        <input name='nome' id='nome' className='form-control text-center colorInput ' disabled={habilitar} value={obra} onChange={(e) => setObra(e.target.value)} ></input>

                                        {/* <input name='obra' id='obra' className='form-control text-center colorInput ' disabled={false} value={cliente} onChange={(e) => setCliente(e.target.value)} ></input> */}

                                    </div>


                                    <div class="col-6">
                                        <h7>Status:</h7>
                                        <input name='cidade' id='cidade' className='form-control text-center colorInput ' disabled={false} value={status} onChange={(e) => setStatus(e.target.value)} ></input>
                                    </div>

                                </div>
                            </div>
                        </body>
                        <br />
                        <br />

                        {/* <div class="row d-flex mt-2 align-items-end justify-content-center ">
                            <div class="col-4">
                                <div className="btn btn-outline-success-center " type="submit">
                                    <button onClick={(e) => (SalvarCadastro(e))} class="btnlogin  me-md-2  " Button > Salvar </button>
                                </div>
                            </div>
                        </div> */}
                        <div class="container text-center">
                            {habilitar === true && (
                                <div className="container">
                                    <div class="row align-items-start">
                                        <div class="col-4">
                                            <div className="btn btn-outline-success-center " >
                                                <button class="btnMenuPesquisa  me-md-2 justify-content-center align-items-center " Button ><Link to='/app/Rdo' style={{ color: '#ffffff', textDecoration: 'none' }} > RDO</Link> </button>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div className="btn btn-outline-success-center "  >
                                                <button class="btnMenuPesquisa  me-md-2 justify-content-center align-items-center " Button ><Link to='/app/CadastroSondagemSub' style={{ color: '#ffffff', textDecoration: 'none' }} > Sondagem</Link> </button>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div className="btnCadastroSondagem btn-outline-success-center " >

                                                <button class="btn btn-secondary dropdown-toggle btn-block hover-effect" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" style={{ backgroundColor: '#18ab29', borderRadius: '100px', width: '107%', height: '46px', fontSize: '20px', marginTop: '5%' }}>Ensaios</button>

                                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style={{ backgroundColor: '#18ab29', width: '35%', height: '100px', fontSize: '20px' }}>

                                                    <li className="nav-link">
                                                        <Link to='/app/PerdaDeAgua' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#18ab29' }}>
                                                            Perda de Água (Lugeon)
                                                        </Link>
                                                    </li>

                                                    <li className="nav-link"> <Link to={{
                                                        pathname: '/app/InfiltracaoEmSolo',
                                                        state: { valor1, valor2 }
                                                    }} className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#18ab29' }}>Infiltração em Solo</Link></li>


                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </form>




                </ContainerForm>
            </Container>

            <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
                <div className="offcanvas-header">
                   
                    <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
                </div>
                <Offcanvas.Body>
                    <ul>
                        <li className={`${liClicked ? 'li-slide-right' : ''}`} >
                            <Link to="/app/TelaSondagem" style={{ textDecoration: 'none' }}>
                                <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
                        </li>
                        {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
                        {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
              <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                <i className="bi bi-chevron-right"></i>
              </span></Button>
            </li> */}
                        {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
                    </ul>
                </Offcanvas.Body>
            </Offcanvas>





        </div>
    </div>
    )



}

export default Cadastro_Sondagem;